module.exports = __webpack_public_path__ + "img/img1.82f77ade.jpg";